export const MAX_CABIN_NUMBER = 8;
export const TOURIST_TAX_PRICE = {
  HRV: 1.35,
  MNE: 1,
}
